import { render, staticRenderFns } from "./rkgl.vue?vue&type=template&id=4dd69542&scoped=true&"
import script from "./rkgl.vue?vue&type=script&lang=js&"
export * from "./rkgl.vue?vue&type=script&lang=js&"
import style0 from "./rkgl.vue?vue&type=style&index=0&id=4dd69542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd69542",
  null
  
)

export default component.exports